import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, LabelList } from 'recharts';
import { formatLargeNumber } from '../../utils/helpers';

const COLORS = {
  product: '#3B82F6',      // Blue
  construction: '#8B5CF6',  // Purple
  use: '#10B981',          // Green
  eol: '#F59E0B'           // Orange
};

const ActivityBarChart = ({ emissions }) => {
  const safe = (v) => (typeof v === 'number' && isFinite(v) ? v : 0);

  const a1a3 = safe(emissions.total_a1) + safe(emissions.total_a2) + safe(emissions.total_a3);
  const a4a5 = safe(emissions.total_a4_a5 || 0);
  const b2b5 = safe(emissions.total_b2_b5 || 0);
  const c1c4 = safe(emissions.total_c1_c4 || 0);
  const total = safe(emissions.total_emissions) || a1a3 + a4a5 + b2b5 + c1c4;

  const data = [
    { 
      name: 'Product (A1–A3)', 
      value: a1a3, 
      percentage: total > 0 ? (a1a3 / total) * 100 : 0, 
      color: COLORS.product 
    },
    { 
      name: 'Construction (A4–A5)', 
      value: a4a5, 
      percentage: total > 0 ? (a4a5 / total) * 100 : 0, 
      color: COLORS.construction 
    },
    { 
      name: 'Use (B2–B5)', 
      value: b2b5, 
      percentage: total > 0 ? (b2b5 / total) * 100 : 0, 
      color: COLORS.use 
    },
    { 
      name: 'End-of-Life (C1–C4)', 
      value: c1c4, 
      percentage: total > 0 ? (c1c4 / total) * 100 : 0, 
      color: COLORS.eol 
    }
  ];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const d = payload[0].payload;
      return (
        <div className="custom-tooltip">
          <p className="tooltip-label">{label}</p>
          <p className="tooltip-value">{`${formatLargeNumber(d.value, { unit: 'kg CO₂e', decimals: 2 })}`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="chart-container">
      <h3>Stage Group Contribution to Total Emissions</h3>
      <ResponsiveContainer width="100%" height={280}>
        <BarChart
          data={data}
          margin={{ top: 24, right: 24, left: 8, bottom: 8 }}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
          <XAxis 
            dataKey="name" 
            tick={{ fontSize: 12, fill: '#475569' }} 
            interval={0}
          />
          <YAxis 
            tickFormatter={(v) => `${v}%`} 
            domain={[0, 100]} 
            tick={{ fontSize: 12, fill: '#475569' }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="percentage" radius={[6, 6, 0, 0]} minPointSize={6}>
            <LabelList 
              dataKey="percentage" 
              position="top" 
              formatter={(v) => `${v.toFixed(1)}%`} 
              fill="#334155" 
              fontSize={11}
              fontWeight={600}
            />
            {data.map((d, i) => (
              <Cell key={`cell-${i}`} fill={d.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      {/* <div className="chart-note">
        <p>* Percentage contribution of each lifecycle stage group to total emissions</p>
      </div> */}
    </div>
  );
};

export default ActivityBarChart;
